
export const scope_access_as_user = `api://${process.env.REACT_APP_AAD_CLIENT_ID!}/access_as_user`;
export const loginRequest = {
  scopes: ["GroupMember.Read.All", "User.ReadBasic.All", scope_access_as_user],
};
export const apiCallRequest = {
  scopes: [scope_access_as_user],
};